import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { ERegisterOrAuthByTokenStatus } from '../../types/phoneAuth';
import { PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE } from '../../constants/action_types';
import { fetchRegisterOrAuthorizeUserByToken } from '../../repositories/users/v1/register-or-authorize-user-by-token';
import { jsonpRequest } from '../../../browser/utils/jsonpRequest';
import { EActiveView, EEventType } from '../../..';
import { trackAuthenticateSuccess, trackRegistrationSuccess } from '../../utils/tracking';
import { changeView } from '../view';
import { saveAccount } from '../../utils/rememberedAccounts';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
export function registerOrAuthorizeByToken() {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState, context) {
      var _getState, view, _getState$phoneAuth, phone, registerOrAuth, senderType, _getState$agreement, licenceAccepted, marketingSubscriptionAccepted, isRememberAccountsFlow, res, _res$response, isRegistered, logOnUrl, token, email;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            dispatch({
              status: ERegisterOrAuthByTokenStatus.Loading,
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE
            });
            _getState = getState(), view = _getState.view, _getState$phoneAuth = _getState.phoneAuth, phone = _getState$phoneAuth.phone, registerOrAuth = _getState$phoneAuth.registerOrAuth, senderType = _getState$phoneAuth.sendValidationCode.senderType, _getState$agreement = _getState.agreement, licenceAccepted = _getState$agreement.licenceAccepted, marketingSubscriptionAccepted = _getState$agreement.marketingSubscriptionAccepted, isRememberAccountsFlow = _getState.isRememberAccountsFlow;
            _context.prev = 2;
            _context.next = 5;
            return fetchRegisterOrAuthorizeUserByToken({
              httpApi: context.httpApi,
              parameters: {
                temporaryToken: registerOrAuth.temporaryToken,
                isAcceptLicence: licenceAccepted,
                hasMarketingSubscriptions: marketingSubscriptionAccepted
              },
              config: {
                requestConfig: {
                  headers: [['Content-Type', 'application/json']],
                  withCredentials: true
                }
              }
            });
          case 5:
            res = _context.sent;
            if (!(res.statusCode === 200)) {
              _context.next = 22;
              break;
            }
            _res$response = res.response, isRegistered = _res$response.isRegistered, logOnUrl = _res$response.logOnUrl, token = _res$response.token, email = _res$response.email;
            _context.prev = 8;
            _context.next = 11;
            return jsonpRequest("".concat(logOnUrl, "?login=").concat(encodeURIComponent(email), "&token=").concat(token, "&persistent=true"));
          case 11:
            dispatch({
              status: ERegisterOrAuthByTokenStatus.Succeed,
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE
            });
            if (isRegistered) {
              context.emitter.emit(EEventType.RegisterSucceed, {
                email: email,
                phone: phone,
                senderType: senderType
              });
              trackRegistrationSuccess({
                senderType: senderType
              });
            } else {
              context.emitter.emit(EEventType.AuthenticateSucceed, {
                email: email,
                phone: phone,
                senderType: senderType
              });
              trackAuthenticateSuccess({
                senderType: senderType
              });
            }
            if (isRememberAccountsFlow) {
              saveAccount({
                type: ERememberedAccountType.Phone,
                value: phone
              });
            }
            _context.next = 20;
            break;
          case 16:
            _context.prev = 16;
            _context.t0 = _context["catch"](8);
            context.logger.error(_context.t0, {
              domain: 'auth-widget.api.registerOrAuthorizeByToken#logon'
            });
            dispatch({
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
              status: ERegisterOrAuthByTokenStatus.Failed,
              error: 'Произошла непредвиденная ошибка'
            });
          case 20:
            _context.next = 23;
            break;
          case 22:
            if (res.statusCode === 400 && res.response.errors.some(function (error) {
              return error.code.includes('tokenExpired');
            })) {
              dispatch({
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
                status: ERegisterOrAuthByTokenStatus.Failed,
                error: res.response.message
              });
              dispatch(changeView(EActiveView.TokenExpiredError));
            } else if (res.statusCode === 400 && res.response.errors.some(function (error) {
              return error.code.includes('LicenceDoesNotAccepted');
            })) {
              dispatch({
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
                status: ERegisterOrAuthByTokenStatus.Succeed
              });
              dispatch(changeView(EActiveView.Agreement, {
                prevView: view.active,
                prevData: view.data
              }));
            } else {
              dispatch({
                type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
                status: ERegisterOrAuthByTokenStatus.Failed,
                error: res.response.message
              });
              dispatch(changeView(EActiveView.AccountSelectError));
            }
          case 23:
            _context.next = 30;
            break;
          case 25:
            _context.prev = 25;
            _context.t1 = _context["catch"](2);
            dispatch({
              status: ERegisterOrAuthByTokenStatus.Failed,
              type: PHONE_AUTH_REGISTER_OR_AUTHORIZE_BY_TOKEN_TYPE,
              error: 'Произошла непредвиденная ошибка'
            });
            dispatch(changeView(EActiveView.AccountSelectError));
            context.logger.error(_context.t1, {
              domain: 'auth-widget.api.registerOrAuthorizeByToken'
            });
          case 30:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[2, 25], [8, 16]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref.apply(this, arguments);
    };
  }();
}